// Chatbot Documentation: https://naranjafintech.atlassian.net/wiki/spaces/SM/pages/526942306312/Componete+chat+flotante

import { Inject, Injectable } from '@angular/core';
const {
  default: webchat,
} = require('@tn-assistedchannels/bik-webchat-botmaker');
import { DOCUMENT } from '@angular/common';

import { PlatformService } from './platform.service';
import { DataLayer } from '../types/contentful';
import { ChatFrom } from '../constants/chatFrom';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  constructor(
    private platform: PlatformService,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  private initialized = false;

  /**
   * Initialize the chatbot. Should be called in app start.
   */
  public initialize(callback: () => void): void {
    // Check if the app is running in the browser, because the chatbot acceses the `document` object.
    if (this.platform.isBrowser && !this.initialized) {
      const script = document.createElement('script') as HTMLScriptElement;
      script.type = 'text/javascript';
      script.async = false;
      script.src = 'https://go.botmaker.com/rest/webchat/p/4GK3B3170V/init.js';
      script.onload = (): void => {
        callback();
      };

      this.initialized = true;
      this._document.body.appendChild(script);
    }
  }

  /**
   * Display the chatbot.
   */
  public show(): void {
    // The chatbot takes approximately 2 seconds to load.
    const TIME = 2000;
    this.initialize(() => setTimeout(webchat.showChat, TIME));
  }

  /**
   * Hide the chatbot.
   */
  public hide(): void {
    webchat.hideChat();
  }

  /**
   * Generate the `DataLayer` object.
   * @param element Element or text that triggered the chatbot.
   * @returns `DataLayer` object to be used in the `dataLayer` service.
   */
  public getDataLayer(element: string): DataLayer {
    return {
      eventName: 'contact',
      eventParams: {
        action: 'open',
        channel: 'chat bot',
        element,
      },
    };
  }

  public setVariables(chatFrom: ChatFrom): void {
    webchat.setVariables({ chatFrom });
  }
}
